import React, { useState, useEffect } from "react";
import { Card, Table,Row,Alert,Col,NavLink as NavLinkRS, Modal} from "react-bootstrap";
import API, { base } from "api.js";
import { Helmet } from "react-helmet";
import ContactUsPremium from "components/Help/ContactUsPremium";
import { connect } from "react-redux";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import ArrowIcon from "../assets/images/images_new/dropdown-icon.svg"
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const Template = (props) => {
  const [data, setData] = useState([]);
  const [paidMember, setPaidMember] = useState(true);
  const [loadmore, setLoadmore] = useState(false);
  // const [activeTab, setActiveTab] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [popup_file, setPopup_file] = useState("");
  const [popup_title, setPopup_title] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [pdfData, setPdfData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadTemplate();
  }, []);

  const loadTemplate = () => {
    setIsLoading(true)
    API({
      method: "GET",
      url: "help?skip=" + data.length + "&type=1",
    })
      .then((response) => {
        let loadmoreValue = true;
        if (response.data.length < 10) {
          loadmoreValue = false;
        }

        setData(prevData => [...prevData, ...response.data]);
        setLoadmore(loadmoreValue);
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      });
  };

  const OpenPDF = (e, file, title, id) => {
    setPopup_file(`${base}${file}`);
    setPopup_title(title);
    setIsOpen(true);
    setSelectedId(id)
  };

  const actionHtml = (paidMember) => {
    return (
      <>
        {!paidMember ? (
          <>
            <img
              className="view-btn-icon"
              src={UpgradeIcon}
              alt="View"
            />Upgrade Plan
          </>
        ) : (
          <>
            View <img
              className="view-btn-icon"
              src={ArrowIcon}
              alt="View"
            />
          </>
        )}
      </>
    );
  }


  const rowAction = (paidMember, rowId, file, title) => {
    let action_url = "/admin/plans";
    let action_class = "upgrade-plan-btn";
    let inner_html = actionHtml(paidMember);

    if (paidMember) {
      // action_url = `/admin/viewpdf/${rowId}`;
      action_url = "javascript:void(0)";
      action_class = "";
    }

    return (
      <a
        href={action_url}
        id="view"
        className={`nav-link view-btn ${action_class}`}
        onClick={(e) => {
          OpenPDF(e, file, title, rowId)
        }}
      >
        {inner_html}
      </a>
    );
  }
  const toggle = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
  };

  useEffect(() => {
    if (selectedId !== null) {
      API({
        method: 'GET',
        url: 'template/' + selectedId
      }).then(data => {
        setPdfData(data.data.data);
      }).catch(() => {
      });
    }
  }, [selectedId]);

  const fileURL = () => {
    // return `${base}${pdfData.pdf}#toolbar=0`;
    // return `${base}/storage/1756700790.pdf#toolbar=0`;
    return popup_file + "#toolbar=0";
  }

  return (
    <>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>
      <div className="content p-0 w-100">
        <DashboardHeader title="Need Help" />
        <div className="need-help-page outer-wrapper">
          <Row>
            <Col xs={12}>
              <Card>
                {!paidMember && (
                  <Alert color="success">
                    Please upgrade your plan to access secret templates.
                  </Alert>
                )}
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="silver-tab" data-bs-toggle="tab" data-bs-target="#silver-tab-pane" type="button" role="tab" aria-controls="silver-tab-pane" aria-selected="true">Help</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="gold-tab" data-bs-toggle="tab" data-bs-target="#gold-tab-pane" type="button" role="tab" aria-controls="gold-tab-pane" aria-selected="false">Contact Us</button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div className="tab-pane fade show active" id="silver-tab-pane" role="tabpanel" aria-labelledby="silver-tab" tabIndex="0">
                    <Card.Body className="table-wrapper p-0">
                      <Table className="w-100">
                        <thead className="text-primary">
                          <tr>
                            <th className="table-counting">#</th>
                            <th className="table-questiong">Question</th>
                            <th className="table-resolution">Resolution</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            isLoading ? (
                              <tr>
                                <td colSpan={3}>
                                  <Spinner />
                                </td>
                              </tr>
                            ) : data?.length === 0 ? (
                              <tr>
                                <td colSpan={3}>
                                  <EmptyData />
                                </td>
                              </tr>
                            ) :
                              data.map((val, key) => {
                                return (
                                  <tr key={key}>
                                    <td>{key + 1}</td>
                                    <td className="">{val.title}</td>
                                    <td>{rowAction(paidMember, val.id, val.pdf, val.title)}</td>
                                  </tr>
                                );
                              })}
                          {loadmore && (
                            <button
                              className="btn"
                              onClick={(e) => {
                                loadTemplate();
                              }}
                            >
                              Load more
                            </button>
                          )}
                        </tbody>
                      </Table>
                    </Card.Body>
                  </div>

                  <div className="tab-pane fade" id="gold-tab-pane" role="tabpanel" aria-labelledby="gold-tab" tabIndex="0">
                    <div className="help-form">
                      <ContactUsPremium />
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </div>

        {isOpen &&
          <Modal
            show={isOpen}
            className="view-pdf-popup"
          >
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                onClick={toggle}
              ></button>
              <h1 className="modal-title" id="exampleModalLabel">
                {popup_title}
              </h1>
            </div>
            <div className="modal-body">
              {pdfData?.pdf && (
                < embed
                  src={fileURL()}
                  style={{
                    width: "100%",
                    height: "85vh"
                  }}
                  frameBorder="0"
                />
              )}
            </div>
          </Modal>
        }
      </div>
    </>
  );
};

export default connect(mapStateToProps, null)(Template);